class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    const closeBtn = this.querySelector('button[type="button"]');
    if (closeBtn) closeBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.close(); });

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  open(event) {
    event.target.closest('details').setAttribute('open', true);
    this.classList.add('details-modal--open');
    document.body.classList.add('overflow-hidden', 'details-modal-open');

    this._backdrop = document.createElement('div');
    this._backdrop.className = 'details-modal-backdrop';
    this._backdrop.setAttribute('aria-hidden', 'true');
    document.body.appendChild(this._backdrop);
    this._backdrop.addEventListener('click', () => this.close(false));

    this.onBodyClickEvent = this.onBodyClickEvent || ((e) => {
      if (e.target === this._backdrop || (e.target.classList && e.target.classList.contains('modal-overlay'))) {
        this.close(false);
      }
    }).bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent, true);

    try {
      const container = this.detailsContainer.querySelector('[tabindex="-1"]');
      const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
      if (container && input && typeof trapFocus === 'function') {
        trapFocus(container, input);
      }
    } catch (err) {
      /* ignore - trapFocusHandlers may not be initialized (script load order) */
    }
  }

  close(focusToggle = true) {
    try {
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(focusToggle ? this.summaryToggle : null);
      }
    } catch (err) {
      /* ignore - trapFocusHandlers may not be initialized yet */
    }
    this.detailsContainer.removeAttribute('open');
    this.classList.remove('details-modal--open');
    document.body.removeEventListener('click', this.onBodyClickEvent, true);
    document.body.classList.remove('overflow-hidden', 'details-modal-open');
    if (this._backdrop && this._backdrop.parentNode) {
      this._backdrop.remove();
    }
    this._backdrop = null;
  }
}

customElements.define('details-modal', DetailsModal);
